<template lang="html">
  <section>
    <header class="header">
      <div class="logo">
        <svg
          class="svg"
          xmlns="http://www.w3.org/2000/svg"
          width="286"
          height="100"
          fill="none"
          viewBox="0 0 286 100"
        >
          <path fill="$red" d="M0 0h286v90l-10 10H0V0z"/>
          <g fill-rule="evenodd" clip-path="url(#clip0)" clip-rule="evenodd">
              <path fill="#fff" d="M60.048 45.648l-1.142.548-1.142-.548-15.943-7.917 7.56-2.901 16.355 7.984-5.688 2.834zm15.963-7.917l-5.708 2.786L53.76 33.12l5.146-1.999 17.105 6.61zM38.957 57.427l.521.961 18.38 16.603.576-3.805L42.1 56.409l-2.283-19.206-3.46-1.336 2.6 21.56zm39.039-20.224L75.73 56.4 59.373 71.166l.6 3.825 18.359-16.603.523-.96 2.603-21.56-3.462 1.335zM58.308 26l-20.945 8.128 2.939 2.374 18.6-7.245 18.605 7.245 2.938-2.374L59.525 26h-1.217zm169.901 17.803c1.153.504 2.146 1.316 2.87 2.345.754 1.187 1.139 2.571 1.107 3.977V63.75h-4.293V50.164c-.031-.778-.365-1.512-.93-2.047-.569-.516-1.266-.87-2.018-1.027-.776-.191-1.582-.234-2.374-.126-.724.08-1.423.305-2.057.663V63.75h-4.331V44.322c.381-.051.757-.132 1.126-.24.461-.144 1.167-.375 2.114-.702 1.143-.34 2.328-.517 3.521-.528.091-.02.186-.02.277 0 .362-.017.725-.01 1.086.02 1.345.073 2.666.388 3.898.931h.004zm-12.724.558l-6.804 19.388h-4.591l-6.805-19.389c1.473.01 2.917-.41 4.154-1.21l4.116 11.99.672 4.093h.316l.673-4.092 4.115-11.99c1.238.798 2.681 1.218 4.154 1.21zm-70.623 8.032c.987.392 1.854 1.038 2.512 1.873.708 1.004 1.069 2.212 1.029 3.44.036 1.418-.411 2.807-1.266 3.94-.822 1.004-1.924 1.743-3.165 2.123-1.316.415-2.708.533-4.076.345-1.416-.2-2.769-.72-3.956-1.518-1.233-.828-2.212-1.982-2.829-3.333l3.246-2.114c.493.869 1.201 1.597 2.057 2.114.764.476 1.633.759 2.531.826.764.09 1.535-.076 2.195-.47.302-.201.55-.474.719-.795.17-.32.256-.678.251-1.041.005-.221-.038-.44-.127-.643-.088-.202-.22-.383-.386-.53-.356-.318-.774-.56-1.228-.71-.502-.144-.995-.279-1.482-.384-.797-.142-1.584-.335-2.356-.577-.829-.254-1.62-.615-2.354-1.076-.752-.451-1.383-1.077-1.84-1.826-.435-.751-.673-1.6-.693-2.47v-.075c-.012-.112-.018-.225-.018-.337-.043-1.324.384-2.621 1.206-3.66.76-.927 1.758-1.628 2.888-2.028 1.135-.41 2.335-.612 3.541-.596 1.171.01 2.327.252 3.404.711 1.222.535 2.335 1.291 3.284 2.23l-2.612 2.863c-.591-.575-1.3-1.015-2.078-1.288-.763-.301-1.574-.464-2.394-.48-.693-.018-1.38.137-1.998.451-.249.136-.463.327-.625.56-.162.232-.269.498-.311.778-.042.28-.018.567.069.836.087.27.235.516.433.719.42.38.92.663 1.463.826.565.2 1.149.34 1.742.422 1.108.16 2.191.46 3.224.894zm9.198-16.055c.512.545.788 1.27.769 2.018.01.725-.266 1.427-.769 1.95-.258.266-.569.475-.913.614-.344.14-.714.205-1.084.193-.359.007-.715-.061-1.046-.2-.331-.14-.63-.346-.876-.607-.254-.257-.454-.561-.59-.896-.136-.335-.204-.693-.201-1.054-.008-.372.058-.742.194-1.088.136-.347.339-.663.597-.93.253-.251.553-.45.882-.585.33-.135.683-.204 1.04-.203.368-.006.734.06 1.077.195.343.136.655.337.92.593zm11.098 23.482V35.589h4.358V51.46l2.038-2.267.02-.039 5.3-5.986h5.44l-8.545 9.484 8.507 11.096h-5.104l-6.449-8.426-1.207 1.23v7.196l-4.173.164h-.23c-.093-.002-.185-.008-.278-.02l-.225-.019c-2.783-.202-4.748-.826-5.896-1.873-.693-.664-1.235-1.47-1.589-2.362-.355-.892-.514-1.849-.467-2.808V35.59h4.351V56.83c-.019.395.047.788.194 1.155.146.366.37.697.656.969.997.595 2.143.896 3.304.865h-.005zm-10.815 3.93h-4.352V43.101h4.352v20.647zm-28.666-21.878h-4.272l2.808-4.65h5.362l-3.898 4.65zm122.771 3.978c-.786-1.015-1.831-1.8-3.027-2.268-1.228-.482-2.538-.723-3.857-.71-1.32-.03-2.631.206-3.859.691-1.375.568-2.6 1.446-3.58 2.566l2.533 2.325c.64-.658 1.427-1.156 2.295-1.451.874-.283 1.795-.384 2.709-.298.849.063 1.661.374 2.336.894.688.545 1.153 1.324 1.304 2.19v1.25c-1.195-.494-2.467-.777-3.758-.837-1.293-.063-2.585.136-3.798.586-1.265.424-2.358 1.246-3.117 2.342-.76 1.096-1.144 2.407-1.097 3.74-.044 1.477.341 2.936 1.107 4.199.67 1.046 1.642 1.864 2.787 2.344 1.229.52 2.545.805 3.879.836 1.437.065 2.876-.029 4.291-.279 1.376-.243 2.726-.61 4.036-1.095V49.674c.032-1.37-.384-2.713-1.186-3.824h.002zM245.3 60.089c-.813.235-1.648.39-2.492.46-.837.074-1.68.012-2.498-.182-.73-.153-1.391-.54-1.88-1.104-.498-.693-.723-1.545-.631-2.393.011-.371.101-.735.264-1.069.164-.333.397-.627.685-.862.597-.453 1.311-.726 2.058-.788.803-.096 1.615-.077 2.412.058.72.088 1.421.289 2.078.595v5.285h.004zm-48.248-12.327c-.191-.638-.492-1.236-.891-1.768-.766-1.048-1.798-1.874-2.988-2.392-1.209-.51-2.505-.781-3.817-.798-.311.003-.622.026-.93.067-1.028.087-2.035.333-2.987.73-.711.31-1.366.735-1.938 1.26-.4.333-.759.714-1.068 1.133-.813 1.15-1.237 2.53-1.208 3.94v7.195c-.031 1.421.392 2.815 1.208 3.978.385.522.837.99 1.345 1.394.511.392 1.069.718 1.661.97.952.402 1.959.658 2.987.759.304.029.614.038.93.038 1.313-.007 2.611-.278 3.817-.797 1.192-.502 2.225-1.319 2.988-2.364.815-1.164 1.237-2.557 1.207-3.978v-7.196c-.006-.734-.113-1.465-.316-2.171zm-4.036 9.367c.006.607-.198 1.198-.576 1.672-.375.453-.849.815-1.385 1.057-.54.22-1.118.334-1.701.336-.312 0-.624-.028-.93-.086-.297-.057-.589-.14-.871-.25-.547-.241-1.033-.602-1.423-1.057-.366-.48-.561-1.068-.554-1.672v-7.196c-.011-.586.186-1.158.554-1.614.386-.428.876-.75 1.423-.932.281-.11.573-.19.871-.24.307-.055.618-.08.93-.077.582 0 1.158.108 1.701.317.536.183 1.013.505 1.385.932.38.451.585 1.024.576 1.614v7.196zM130.779 45.85c-.785-1.016-1.831-1.8-3.026-2.268-1.228-.482-2.538-.724-3.858-.71-1.226-.028-2.447.174-3.6.595-.088.026-.174.058-.257.096-1.376.567-2.601 1.446-3.58 2.566l2.532 2.325c.386-.39.825-.724 1.305-.99.316-.182.646-.337.989-.461.874-.283 1.796-.384 2.71-.298.849.063 1.661.374 2.336.894.688.545 1.152 1.325 1.305 2.19v1.25c-1.196-.494-2.468-.776-3.76-.837-1.214-.063-2.429.107-3.58.5-.081.029-.153.057-.217.086-1.264.424-2.358 1.246-3.117 2.342-.76 1.096-1.145 2.407-1.098 3.74.003.828.116 1.652.336 2.45h-14.777l15.589-20.724-1.404-2.988H96.081v4.516h14.7L95.253 60.732l1.226 3.017h19.961v-3.756c.207.511.473.998.79 1.45.221.293.467.566.733.817.527.489 1.136.879 1.8 1.153.171.077.349.154.534.221 1.074.382 2.203.59 3.343.615 1.436.065 2.876-.029 4.292-.279 1.376-.243 2.726-.61 4.036-1.095V49.674c.032-1.37-.385-2.713-1.188-3.824h-.001zm-3.143 14.239c-.816.235-1.653.39-2.499.46-.835.073-1.676.012-2.492-.182-.73-.152-1.39-.54-1.879-1.104-.216-.268-.377-.574-.475-.904-.138-.483-.191-.987-.157-1.489.02-.265.073-.526.157-.778.136-.458.413-.861.792-1.153.597-.453 1.31-.726 2.057-.788.803-.096 1.615-.077 2.413.058.719.088 1.421.289 2.078.595v5.285h.005z"/>
              <path fill="#DEDEDE" d="M57.97 47.906l.825 20.907-14.917-13.49-2.096-17.37 16.187 9.953z"/>
              <path fill="#B4B4B4" d="M70.753 41.19l5.278-3.238-2.078 17.371-14.934 13.509.823-20.926 6.552-4.045-.432 10.261 4.08-2.882.71-10.05z"/>
          </g>
          <defs>
              <clipPath id="clip0">
                  <path
                    fill="#fff"
                    d="M0 0H213.295V49H0z"
                    transform="translate(36.352 26)"
                  />
              </clipPath>
          </defs>
        </svg>
      </div>
    </header>
  </section>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";
section {
  height: 0;
}
.header {
  margin: 0 auto;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 22px;
	text-align: center;
	letter-spacing: 0.01em;
	color: #000000;
	height: 40px;
	display: block;
	z-index: 20;
	position: relative;
	top: 0;
	padding: 0 $pad-side;
	left: 0;
	user-select: none;
	.logo {
		background: $red;
		width: 143px;
		height: 50px;
		position: relative;
		z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    &::after {
      content: '';
      background: url("~@/assets/icons/A-logo.svg") center bottom no-repeat;
      position: absolute;
      bottom: -1px;
      right: -1px;
      width: 9px;
      height: 9px;
      transform: rotate(180deg);
    }
		.svg {
			width: 143px;
		}
		&:hover {
			.svg {
				opacity: 0.8;
			}
		}
	}
}
@media screen and (min-width: 1090px) {
	.header {
		left: auto;
		height: 70px;
		background-color: white;
		.logo {
			background: $red;
			width: 286px;
			height: 100px;
			position: relative;
			.svg {
				margin-top: -5px;
				width: 286px;
			}
			&:hover {
				.svg {
					opacity: 0.8;
				}
			}
		}
	}
}
@media screen and (min-width: 1400px) {
	.header {
		padding: 0 $pad-side-l;
	}
}
@media screen and (min-width: 2000px) {
	.header {
    max-width: 1400px;
	}
}
</style>
